import { Form } from 'antd';
import PropType from 'prop-types';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OperatorSelectFields } from '../OperatorForm/OperationSelectFields';
import { updateOperator } from '../state/operation';
import * as selector from '../state/selector';

export const OperatorExpandable = ({
  rowData,
  emailPhoneFieldsRowData,
  responsibilities
}) => {
  const [form] = Form.useForm();
  const operatorId = rowData.id;
  const dispatch = useDispatch();
  const { updateOperatorInfo } = useSelector((state) => ({
    updateOperatorInfo: selector.updateOperatorInfo(state)
  }));

  const isLoading = useMemo(
    () => !!updateOperatorInfo.updatingOperatorValues?.[operatorId],
    [operatorId, updateOperatorInfo.updatingOperatorValues]
  );

  const onFinish = useCallback(
    (values) => {
      values = {
        ...values,
        ...emailPhoneFieldsRowData[rowData.id]
      };
      dispatch(updateOperator(rowData.id, values));
    },
    [dispatch, rowData.id, emailPhoneFieldsRowData]
  );

  return (
    <div className="px-8">
      <Form initialValues={rowData} onFinish={onFinish} form={form}>
        <OperatorSelectFields
          responsibilities={responsibilities}
          isLoading={isLoading}
          setFieldsValue={form.setFieldsValue}
        />
      </Form>
    </div>
  );
};

OperatorExpandable.propTypes = {
  rowData: PropType.objectOf(
    PropType.oneOfType([
      PropType.object,
      PropType.number,
      PropType.string,
      PropType.bool
    ])
  ).isRequired,
  responsibilities: PropType.arrayOf(
    PropType.shape({
      id: PropType.number,
      label: PropType.string,
      name: PropType.string,
      value: PropType.bool
    })
  ).isRequired,
  emailPhoneFieldsRowData: PropType.objectOf(PropType.objectOf(PropType.bool))
    .isRequired
};

export default OperatorExpandable;
